import { SettingsLissenerScreen } from "@components/Account/Settings";

export default SettingsLissenerScreen;
